// extracted by mini-css-extract-plugin
module.exports = {"name":"PluginData_name__pjAYa","spacer":"PluginData_spacer__RheY4"};